module.exports = __webpack_public_path__ + "img/card1.bccd0a1f.png";